document.addEventListener("DOMContentLoaded", function () {

  const overlay = document.querySelector(".cpp-overlay");
  if (!overlay) return;

  const closeBtn = overlay.querySelector(".cpp-close");

  const TRANSITION_MS = 200;
  const pageId = overlay.dataset.popupPage || "default";

  const VISITS_KEY = "retention_cpp_promo_visits_" + pageId;
  const LAST_SHOWN_KEY = "retention_cpp_promo_last_shown_" + pageId;

  const COOLDOWN_HOURS = 12;
  const COOLDOWN_MS = COOLDOWN_HOURS * 60 * 60 * 1000;

  /* ---------- localStorage protegido ---------- */
  function storageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  /* ---------- Abrir / cerrar ---------- */
  let isOpen = false;

  function openPopup() {
    isOpen = true;
    overlay.style.display = "flex";
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add("is-visible");
      });
    });
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove("is-visible");
    setTimeout(function () {
      overlay.style.display = "none";
    }, TRANSITION_MS);
  }

  /* ---------- Contador de visitas + cooldown ---------- */
  let visits = parseInt(storageGet(VISITS_KEY) || "0", 10);
  const lastShown = parseInt(storageGet(LAST_SHOWN_KEY) || "0", 10);
  const now = Date.now();

  // ¿Ya expiró el cooldown desde la última vez que se mostró?
  const cooldownExpired = lastShown === 0 || (now - lastShown) > COOLDOWN_MS;

  // Si el cooldown expiró Y ya habíamos completado un ciclo (visits>=2),
  // arrancamos un ciclo nuevo desde cero
  if (cooldownExpired && visits >= 2) {
    visits = 0;
  }

  visits++;
  storageSet(VISITS_KEY, visits);

  if (visits >= 2 && cooldownExpired) {
    openPopup();
    storageSet(LAST_SHOWN_KEY, now);
  }

  /* ---------- Formas de cerrar ---------- */

  // Botón X
  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  // Clic afuera (en el fondo oscuro, no dentro de la tarjeta)
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closePopup();
  });

  // Tecla Escape
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePopup();
  });

});